import Grid from '../../grid/Grid';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import LLAdminPreviewTab from '../previewTab/previewPane';
import { ReactComponent as Add } from '../../../icons/AddNew.svg';
import loader from '../../../assets/loader.gif';
import { config } from '../../grid/config';
import { useCallback, useEffect, useState } from 'react';
import { getEndPoint } from '../../contactTabs/utils';
import axios from 'axios';
import { ContactType } from '../../contactTabs/constants';
import {
    getAccessMgmtEndPoint,
    userMgmtHeaders,
    generateGridData,
} from '../../accessMgmt/utils';
import AddAccessManagementScreen from '../../accessMgmt/addScreen/addScreen';
import {
    setCountryCodesList,
    setLocationData,
    setLungaguesData,
    setTimeZonesData,
} from '../../accessMgmt/accessmgmtReducer';
import notify from '../../../services/toasterService';
import UserMngmtGrid from '../../grid/access-mngmt-grid/access-mngmt-grid';
import AccessPreviewTab from '../../accessMgmt/previewAccessMgmt/previewaccessmgmt';

export default function AdminUserManagement() {
    const [dataSource, setDataSource] = useState<any>([]);
    const [addScreen, setAddScreen] = useState(false);
    const dispatch = useDispatch();

    /* Get Client data from Grid Reducer */
    const selectedRowData = useSelector(
        (state: RootState) => state.gridReducer.selectedRowData
    );
    // //console.log(selectedRowData, 'selectedRowData');

    /* Get Client data from LL admin Reducer */
    // const clientMgmt = useSelector(
    //     (state: RootState) => state.lladminReducer.clientsData
    // );

    const loaderStatus = useSelector(
        (state: RootState) => state.lladminReducer.isLoaderShow
    );
    let gridHieght = 'calc(100vh - 400px)';

    useEffect(() => {
        // getUserDetails();
        getUserSelectionFields('Default Language');
        getUserSelectionFields('Default TimeZone');
        getUserSelectionFields('Reclaim Centers List');
        getUserSelectionFields('Default Country');
    }, []);

    const getUserDetails = useCallback(async () => {
        try {
            const endPointURL = getAccessMgmtEndPoint('Users');

            const response = await axios.get(endPointURL);
            if (response.status === 200) {
                setDataSource(response.data || []);
            }
        } catch (error) {}
    }, []);

    const getUserSelectionFields = async (fieldName: any) => {
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        await axios.get(getEndPointUrl).then(
            (res) => {
                if (fieldName === 'Default Language') {
                    dispatch(setLungaguesData(res.data));
                } else if (fieldName === 'Default TimeZone') {
                    dispatch(setTimeZonesData(res.data));
                } else if (fieldName === 'Reclaim Centers List') {
                    dispatch(setLocationData(res.data));
                } else if (fieldName === 'Default Country') {
                    dispatch(setCountryCodesList(res.data));
                }
            },
            (err) => {
                notify('Failed to fetch data', 'error');
            }
        );
    };

    return (
        <div>
            {addScreen && (
                <AddAccessManagementScreen
                    addScreen={addScreen}
                    setAddScreen={setAddScreen}
                    tabName={'Users'}
                />
            )}

            <div className="col-sm-12 col-md-12 col-lg-12 pt-5">
                <div className="col-sm-6 pl-0">
                    <p className="child-tab-title">Admin Users</p>
                </div>
                <div className="col-sm-6 pr-0">
                    <ButtonComponent className="iconCopy float-right ml-1">
                        <Add onClick={() => setAddScreen(true)} />
                    </ButtonComponent>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 ">
                <div className="control-pane">
                    <div className="control-section tab-control-section">
                        <div className="col-sm-12 col-md-12 col-lg-12 ">
                            <div
                                className="col-sm-8 col-md-12 col-lg-8 pl-0 pr-4 "
                                style={{ width: '75%' }}
                            >
                                <>
                                    {loaderStatus ? (
                                        <div className="LoadImg">
                                            <img
                                                className="loaderClass"
                                                src={loader}
                                            />
                                        </div>
                                    ) : (
                                         <UserMngmtGrid
                                                height={gridHieght}
                                                width={'100%'}
                                            />
                                    )}
                                </>
                            </div>
                            {selectedRowData && selectedRowData.length > 0 ? (
                                <div
                                    className="col-sm-4 col-md-12 col-lg-4 pl-4 "
                                    style={{ width: '25%', height: gridHieght }}
                                >
                                    <AccessPreviewTab />
                                </div>
                            ) : (
                                <div
                                  className="col-sm-4 col-md-12 col-lg-4 pl-4 "
                                    style={{ width: '25%',height: gridHieght }}
                                >
                                    <div className="childTab-preview-pane-admin d-flex align-items-center">
                                        <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                            <p className="preview-msg">
                                                Select Admin User to view
                                                details
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
